import { createSlice } from '@reduxjs/toolkit';

let notificationId = 0;

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: [],
  },
  reducers: {
    addNotification: (state, action) => {
      const { type = 'info', message, duration = 5000 } = action.payload;
      state.notifications.push({
        id: ++notificationId,
        type,
        message,
        duration,
        timestamp: Date.now(),
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
    },
    clearAllNotifications: (state) => {
      state.notifications = [];
    },
  },
});

export const { addNotification, removeNotification, clearAllNotifications } = notificationSlice.actions;

// Helper action creators for common notification types
export const showSuccess = (message) => addNotification({ type: 'success', message });
export const showError = (message) => addNotification({ type: 'error', message, duration: 7000 });
export const showWarning = (message) => addNotification({ type: 'warning', message });
export const showInfo = (message) => addNotification({ type: 'info', message });

export default notificationSlice.reducer;
